export { default } from './InputMask';
